/** ISO landscape (A4/A3): alto / ancho — mismo ratio √2. */
export const PAGE_A4_LANDSCAPE_RATIO = 210 / 297;

/** Rango estilo Illustrator (~3.13% … 6400%). */
export const PAGE_VIEW_ZOOM_MIN = 0.03125;
export const PAGE_VIEW_ZOOM_MAX = 64;
export const PAGE_VIEW_ZOOM_STEP = 0.1;

export function clampPageViewZoom(z) {
  const n = Number(z);
  if (!Number.isFinite(n)) return 1;
  return (
    Math.round(
      Math.min(PAGE_VIEW_ZOOM_MAX, Math.max(PAGE_VIEW_ZOOM_MIN, n)) * 100,
    ) / 100
  );
}

/**
 * Zoom de vista para que la página A4 quepa en el recuadro (ancho y alto).
 * El lienzo usa width = zoom * availW.
 */
export function pageViewZoomToFit({
  availW,
  availH,
  min = PAGE_VIEW_ZOOM_MIN,
  max = 1,
  ratio = PAGE_A4_LANDSCAPE_RATIO,
} = {}) {
  const w = Number(availW);
  const h = Number(availH);
  const r = Number(ratio);
  if (!(w > 8) || !(h > 8) || !(r > 0)) return null;
  const z = h / (w * r);
  const lo = Number.isFinite(Number(min)) ? Number(min) : PAGE_VIEW_ZOOM_MIN;
  const hi = Number.isFinite(Number(max)) ? Number(max) : 1;
  const raw = Math.min(hi, Math.max(lo, z));
  return clampPageViewZoom(Math.floor(raw * 100) / 100);
}

export function pageViewZoomFromScrollBox(el) {
  if (!el || typeof window === "undefined") return null;
  const rect = el.getBoundingClientRect();
  const style = window.getComputedStyle(el);
  const padX =
    (parseFloat(style.paddingLeft) || 0) +
    (parseFloat(style.paddingRight) || 0);
  const padY =
    (parseFloat(style.paddingTop) || 0) +
    (parseFloat(style.paddingBottom) || 0);
  return pageViewZoomToFit({
    availW: Math.max(el.clientWidth || 0, rect.width) - padX,
    availH: Math.max(el.clientHeight || 0, rect.height) - padY,
  });
}
